import React, { memo, useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import _ from 'lodash'

import { useDispatch } from 'reduxStoreHelper'
import Header from '../components/Header'
import {
  Wrapper,
  Content,
  WrapperTitleCustom,
  HeaderBox,
  LabelTitleBottom,
  WrapperButton,
  TextBold,
  ButtonOutline,
  ImageLogo,
} from '../style'
import { ButtonRedirectMode, INTEGRATED_RECEPTION_URL_BASE } from '../constants'
import { fetchSuccess, setGeneralReceptionDetail } from '../reducer'
import { startLoading, stopLoading, openError } from 'containers/App/reducers'
import { getGeneralReceptionDetail } from '../api'
import MonofulLogo from 'assets/svgs/monoful-logo-background-white.svg'
import theme from 'vars/theme'
import PrevStartButton from '../components/PrevStartButton'
import SessionStorage from 'containers/Reception/SessionStorage'

type props = {
  generalReceptionId?: string
}

const EntryPage: React.FC<props> = ({ generalReceptionId }) => {
  const { generalReceptionNumber }: any = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation<{ multiTenantId: string }>()

  const multiTenantSession = SessionStorage.read('multiTenantId')

  useEffect(() => {
    const { multiTenantId = '' } = location.state || {
      multiTenantId: multiTenantSession || '',
    }
    SessionStorage.write('multiTenantId', multiTenantId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch(
      fetchSuccess({
        key: 'isReturnEntryPage',
        data: false,
      })
    )
  }, [dispatch])

  useEffect(() => {
    ;(async () => {
      dispatch(startLoading())
      try {
        const data = await getGeneralReceptionDetail(generalReceptionId)
        const generalReceptionDetail = _.get(data, 'data', {})
        dispatch(setGeneralReceptionDetail(generalReceptionDetail))
      } catch (err) {
        // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
        dispatch(openError(err.message, false))
      } finally {
        dispatch(stopLoading())
      }
    })()
  }, [dispatch, generalReceptionId])

  const handleClickRedirectPage = (mode: string) => {
    if (mode === ButtonRedirectMode.CHECKIN) {
      return history.push(
        `${INTEGRATED_RECEPTION_URL_BASE}/entry-tel-number/${generalReceptionNumber}`
      )
    }
    history.push(`${INTEGRATED_RECEPTION_URL_BASE}/exit/${generalReceptionNumber}`)
  }

  const handleMultiTenantNavigation = () => {
    history.push(`/mtenants/${multiTenantSession}`)
  }

  return (
    <Wrapper style={{ minWidth: 1024 }}>
      <Header />
      <Content>
        <WrapperTitleCustom>
          <LabelTitleBottom>
            <ImageLogo src={MonofulLogo} alt="hacobell logo" />
            トラック簿
          </LabelTitleBottom>
          <WrapperButton className="mx-auto">
            <ButtonOutline
              color={theme.blueMedium5}
              onClick={() => handleClickRedirectPage(ButtonRedirectMode.CHECKIN)}
              data-dg-id="entry-page-checkin-button"
            >
              <TextBold>入場</TextBold>受付
            </ButtonOutline>
            <ButtonOutline
              color={theme.redPrimary1}
              onClick={() => handleClickRedirectPage(ButtonRedirectMode.CHECKOUT)}
              data-dg-id="entry-page-checkout-button"
            >
              <TextBold>退場</TextBold>受付
            </ButtonOutline>
          </WrapperButton>
        </WrapperTitleCustom>

        <div className="d-flex justify-content-between">
          <HeaderBox />
          <HeaderBox />
        </div>

        <div className="d-flex justify-content-between">
          <div style={{ width: '33%' }}>
            {multiTenantSession && (
              <PrevStartButton
                onClick={handleMultiTenantNavigation}
                data-dg-id="entry-page-prev-start-button"
              />
            )}
          </div>
          <div style={{ width: '34%' }} />
          <div style={{ width: '33%' }} />
        </div>
      </Content>
    </Wrapper>
  )
}

export default memo(EntryPage)
